(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-numbers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    initAnimatedStats();
  });

  document.addEventListener('shopify:section:load', (e) => {
    initAnimatedStats(e.target);
  });

  function initAnimatedStats(context = document) {
    const sections = context.classList && context.classList.contains('ph-stats')
      ? [context]
      : context.querySelectorAll('.ph-stats');

    sections.forEach((section) => {
      const counters = section.querySelectorAll('.js-stat-counter');
      if (!counters.length) return;

      let hasAnimated = false;

      function triggerAnimation() {
        if (hasAnimated) return;
        hasAnimated = true;
        section.classList.add('is-in-view');

        counters.forEach((counter) => {
          const rawTarget = counter.dataset.targetValue;
          const prefix = counter.dataset.prefix || '';
          const suffix = counter.dataset.suffix || '';
          const duration = parseInt(counter.dataset.duration, 10) || 2000;

          // Check if target is a clean number
          const numericTarget = parseFloat(rawTarget);

          if (isNaN(numericTarget)) {
            // Text like "Fully"
            counter.textContent = `${prefix}${rawTarget || ''}${suffix}`;
            return;
          }

          // Counter animation with easeOutExpo
          const startTime = performance.now();

          function step(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            // easeOutExpo curve
            const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            const currentVal = Math.floor(ease * numericTarget);

            counter.textContent = `${prefix}${currentVal.toLocaleString()}${suffix}`;

            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              counter.textContent = `${prefix}${numericTarget.toLocaleString()}${suffix}`;
            }
          }

          requestAnimationFrame(step);
        });
      }

      // Expose function on DOM element for GSAP / Lenis integration
      section.startCountAnimation = triggerAnimation;

      /* -----------------------------------------------------------
         INTERSECTION OBSERVER (Natively compatible with Lenis / Native)
         ----------------------------------------------------------- */
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              triggerAnimation();
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.25,
          rootMargin: '0px 0px -50px 0px'
        });

        observer.observe(section);
      } else {
        // Fallback for older browsers
        triggerAnimation();
      }

      /* -----------------------------------------------------------
         OPTIONAL GSAP / SCROLLTRIGGER HOOK
         If GSAP ScrollTrigger is initialized later by the theme
         ----------------------------------------------------------- */
      if (window.gsap && window.ScrollTrigger) {
        window.ScrollTrigger.create({
          trigger: section,
          start: 'top 80%',
          once: true,
          onEnter: () => triggerAnimation()
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    initBeforeAfterSliders();
  });

  document.addEventListener('shopify:section:load', (e) => {
    initBeforeAfterSliders(e.target);
  });

  function initBeforeAfterSliders(context = document) {
    const cards = context.classList && context.classList.contains('js-ba-card')
      ? [context]
      : context.querySelectorAll('.js-ba-card');

    cards.forEach((card) => {
      const range = card.querySelector('.js-ba-range');
      if (!range) return;

      function updateSlider(val) {
        card.style.setProperty('--pos', `${val}%`);
      }

      // Input range event (handles keyboard, screen-reader, direct slider drags)
      range.addEventListener('input', (e) => {
        updateSlider(e.target.value);
      });

      // Pointer event tracking for effortless click & drag anywhere across the card
      let isDragging = false;

      function getPosFromEvent(e) {
        const rect = card.getBoundingClientRect();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const x = clientX - rect.left;
        let percent = (x / rect.width) * 100;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        return percent;
      }

      function handleDragMove(e) {
        if (!isDragging) return;
        const percent = getPosFromEvent(e);
        range.value = percent;
        updateSlider(percent);
      }

      card.addEventListener('pointerdown', (e) => {
        isDragging = true;
        const percent = getPosFromEvent(e);
        range.value = percent;
        updateSlider(percent);
      });

      window.addEventListener('pointermove', handleDragMove, { passive: true });

      window.addEventListener('pointerup', () => {
        isDragging = false;
      });

      window.addEventListener('pointercancel', () => {
        isDragging = false;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facility-operations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    initFacilityModals();
  });

  document.addEventListener('shopify:section:load', (e) => {
    initFacilityModals(e.target);
  });

  function initFacilityModals(context = document) {
    const triggers = context.querySelectorAll('.js-facility-video-open');
    triggers.forEach((trigger) => {
      const sectionId = trigger.dataset.sectionId;
      const modal = document.getElementById(`ph-facility-modal-${sectionId}`);
      if (!modal) return;

      const iframe = modal.querySelector('iframe');
      const closeButtons = modal.querySelectorAll('.js-facility-modal-close');
      const videoEl = modal.querySelector('video');

      function openModal() {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        if (iframe && iframe.dataset.src && !iframe.src) {
          iframe.src = iframe.dataset.src;
        }
        if (videoEl) {
          videoEl.play().catch(() => {});
        }
      }

      function closeModal() {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (iframe && iframe.src) {
          iframe.src = '';
        }
        if (videoEl) {
          videoEl.pause();
        }
      }

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          closeModal();
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-active')) {
          closeModal();
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__phHeaderInit) return;
    window.__phHeaderInit = true;

    var header   = document.getElementById('ph-site-header');
    var toggle   = document.getElementById('ph-nav-toggle');
    var drawer   = document.getElementById('ph-nav-drawer');
    var THRESHOLD = 60;

    /* Scroll → frosted-glass */
    function onScroll() {
      if (!header) return;
      header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Hamburger toggle */
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        toggle.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        drawer.setAttribute('aria-hidden', String(!open));
        if (open) header.classList.add('is-scrolled');
      });

      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          drawer.classList.remove('is-open');
          toggle.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          drawer.setAttribute('aria-hidden', 'true');
          onScroll();
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          drawer.classList.remove('is-open');
          toggle.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          drawer.setAttribute('aria-hidden', 'true');
          toggle.focus();
          onScroll();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-projects"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    initProjectsSection();
  });

  document.addEventListener('shopify:section:load', (e) => {
    initProjectsSection(e.target);
  });

  function initProjectsSection(context = document) {
    const sections = context.classList && context.classList.contains('ph-projects')
      ? [context]
      : context.querySelectorAll('.ph-projects');

    sections.forEach((section) => {
      const slider = section.querySelector('.js-projects-slider');
      const prevBtn = section.querySelector('.js-projects-prev');
      const nextBtn = section.querySelector('.js-projects-next');
      const modal = section.querySelector('.js-project-modal');
      const modalTarget = section.querySelector('.js-project-modal-target');
      const cardTriggers = section.querySelectorAll('.js-project-card-trigger');
      const closeButtons = section.querySelectorAll('.js-project-modal-close');

      /* -----------------------------------------------------------
         1. SLIDER FUNCTIONALITY (Activates smoothly after 3 items)
         ----------------------------------------------------------- */
      if (slider && prevBtn && nextBtn) {
        function updateArrowState() {
          const maxScrollLeft = slider.scrollWidth - slider.clientWidth - 5;
          const isScrollable = slider.scrollWidth > slider.clientWidth + 10;

          if (!isScrollable) {
            prevBtn.disabled = true;
            nextBtn.disabled = true;
            return;
          }

          prevBtn.disabled = slider.scrollLeft <= 10;
          nextBtn.disabled = slider.scrollLeft >= maxScrollLeft;
        }

        function scrollSlide(direction) {
          const firstSlide = slider.querySelector('.js-projects-slide');
          if (!firstSlide) return;
          const slideWidth = firstSlide.offsetWidth;
          const gap = 28;
          const amount = (slideWidth + gap) * direction;

          slider.scrollBy({ left: amount, behavior: 'smooth' });
        }

        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          scrollSlide(-1);
        });

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          scrollSlide(1);
        });

        slider.addEventListener('scroll', () => {
          updateArrowState();
        }, { passive: true });

        window.addEventListener('resize', () => {
          updateArrowState();
        });

        // Initialize state
        setTimeout(updateArrowState, 150);
      }

      /* -----------------------------------------------------------
         2. BIG WIDTH PROJECT MODAL
         ----------------------------------------------------------- */
      if (modal && modalTarget && cardTriggers.length > 0) {
        function openProjectModal(card) {
          const template = card.querySelector('.js-project-modal-template');
          if (!template) return;

          // Clone template content into modal target
          modalTarget.innerHTML = '';
          modalTarget.appendChild(template.content.cloneNode(true));

          // Open dialog
          modal.classList.add('is-active');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';

          // Focus close button for accessibility
          const closeBtn = modal.querySelector('.ph-modal__close-btn');
          if (closeBtn) closeBtn.focus();
        }

        function closeProjectModal() {
          modal.classList.remove('is-active');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }

        cardTriggers.forEach((card) => {
          card.addEventListener('click', (e) => {
            e.preventDefault();
            openProjectModal(card);
          });

          card.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openProjectModal(card);
            }
          });
        });

        closeButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            closeProjectModal();
          });
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.classList.contains('is-active')) {
            closeProjectModal();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    initTestimonialsSlider();
  });

  document.addEventListener('shopify:section:load', (e) => {
    initTestimonialsSlider(e.target);
  });

  function initTestimonialsSlider(context = document) {
    const sections = context.classList && context.classList.contains('ph-testimonials')
      ? [context]
      : context.querySelectorAll('.ph-testimonials');

    sections.forEach((section) => {
      const slider = section.querySelector('.js-testimonials-slider');
      const prevBtn = section.querySelector('.js-testimonials-prev');
      const nextBtn = section.querySelector('.js-testimonials-next');

      if (!slider || !prevBtn || !nextBtn) return;

      function updateArrowState() {
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth - 5;
        const isScrollable = slider.scrollWidth > slider.clientWidth + 10;

        if (!isScrollable) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }

        prevBtn.disabled = slider.scrollLeft <= 10;
        nextBtn.disabled = slider.scrollLeft >= maxScrollLeft;
      }

      function scrollSlide(direction) {
        const firstSlide = slider.querySelector('.js-testimonials-slide');
        if (!firstSlide) return;
        const slideWidth = firstSlide.offsetWidth;
        const gap = 28;
        const amount = (slideWidth + gap) * direction;

        slider.scrollBy({ left: amount, behavior: 'smooth' });
      }

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        scrollSlide(-1);
      });

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        scrollSlide(1);
      });

      slider.addEventListener('scroll', () => {
        updateArrowState();
      }, { passive: true });

      window.addEventListener('resize', () => {
        updateArrowState();
      });

      setTimeout(updateArrowState, 150);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
